<template>
  <div
    class="container"
    :class="appClasses"
    :style="cssVars"
  >
    <transition :name="transitionName">
      <router-view class="child-view"></router-view>
    </transition>
    <CardDeclined
      v-if="isCardDeclined"
      title="Oops"
      text="It looks like something went wrong. Please add or update your credit card on file."
      bg-image="card-declined"
      @connect="goToSettings('manipulateCards')"
    />
    <LoginRequired
      v-if="isLoginRequired"
      title="Oops"
      text="It looks like your bank account was disconnected. Connect again to continue being a change maker!"
      bg-image="login-required"
      @connect="goToSettings('bankAccount')"
    />
    <PaymentModal
      v-if="$store.state.paymentModal"
      title="Oops"
      :text="$t('popuptext')"
      bg-image="login-required"
      @connect="initPlaid"
    />
    <div
      v-if="isSpinner"
      class="spinner-loader animate-spin inline-block w-8 h-8 border-4 rounded-full"
      role="status"
    />
  </div>
</template>

<script>
import TimeMe from "timeme.js";
import CardDeclined from "../components/Modal/CommonModal.vue";
import LoginRequired from "../components/Modal/CommonModal.vue";
import PaymentModal from "../components/Modal/CommonModal.vue";
import mixins from "../config/mixins";

export default {
  mixins: [mixins.npos, mixins.plaid],
  components: {
    CardDeclined,
    LoginRequired,
    PaymentModal
  },
  data() {
    return {
      // langs: ["es", "en"]
      transitionName: "slide-left",
      timeHash: "",
      isCardDeclined: false,
      isLoginRequired: false,
      bgColor: "#DB8633",
      btnColor: "#E78F39",
      titleColor: "#DB8633",
      subTitleColor: "#294F59",
      content: "#4A4B4D",
      linkColor: "",
      backBtnColor: "#DB8633",
      iconColor: "#DB8633",
      navIconColor: "#ADCAB8",
      savingTagColor: "#90AFAF",
      shareBtnColor: "rgb(50, 78, 88)",
      heartBg: "#DB8633",
      btnTextSummary: "#324e58"
    };
  },

  computed: {
    cssVars() {
      if (this.$getState("corporation")["is"]) {
        this.bgColor = this.$getState("corporation")["color_background"] || this.bgColor;
        this.btnColor = this.$getState("corporation")["button_color"] || this.btnColor;
        this.titleColor = this.$getState("corporation")["color_input"] || this.titleColor;
        this.content = this.$getState("corporation")["sub_text_color"] || this.content;
        this.subTitleColor = this.$getState("corporation")["sub_text_color"] || this.subTitleColor;
        this.linkColor = this.$getState("corporation")["link_color"] || this.linkColor;
        this.backBtnColor = this.$getState("corporation")["back_button_color"] || this.backBtnColor;
        this.iconColor = this.$getState("corporation")["icon_color"] || this.iconColor;
        this.navIconColor = this.$getState("corporation")["nav_icon_color"] || this.navIconColor;
        this.savingTagColor = this.$getState("corporation")["saving_tag_color"] || this.savingTagColor;
        this.shareBtnColor = this.$getState("corporation")["button_color"]
        this.heartBg = this.$getState("corporation")["nav_icon_color"]
        this.btnTextSummary = this.$getState("corporation")["button_color"]
      }
      return {
        // '--font-family': this.fontFamily,
        "--bg-color": this.bgColor,
        "--btn-color": this.btnColor,
        "--back-btn-color": this.backBtnColor,
        "--text-color": this.titleColor,
        "--sub-text-color": this.subTitleColor,
        "--content-color": this.content,
        "--link-color": this.linkColor,
        "--icon-color": this.iconColor,
        "--nav-icon-color": this.navIconColor,
        "--saving-tag-color": this.savingTagColor,
        "--share-btn-color": this.shareBtnColor,
        "--heart-bg-color": this.heartBg,
        "--btn-text-summary": this.btnTextSummary
      };
    },
    isSpinner() {
      return (
        this.$getState("isSpinner") &&
        (this.$route.path == "/locations" || this.$route.path == "/dashboard")
      );
    },
    isRouteAllowed() {
      return (
        this.$route.path == "/login" || this.$route.path == "/device-selection"
      );
    },
    isLoad () {
      let clas = ''
      if (this.$store.state.load) {
        clas = 'process-loading-dots'
      } else if (this.$store.state.loader) {
        clas = 'process-loading'
      }
      return clas
    },
    appClasses () {
      return [
        this.isLoad,
        this.$getState('theme'),
        this.$getState('device')
      ]
    }
  },

  watch: {
    $route(to, from) {
      if (navigator && navigator.onLine !== undefined) {
        if (!navigator.onLine) {
          this.$toastr.Add({
            name: "UserOffline",
            msg: "Check internet connection",
            clickClose: true,
            type: "error",
            preventDuplicates: true
          });
        }
      }

      const routeDeep = [
        "/",
        "/login",
        "/privacy-policy",
        "/terms-of-service",
        "/dashboard",
        "/giving",
        "/npos",
        "/locations",
        "/settings"
      ];
      const toDepth = routeDeep.indexOf(to.path);
      const fromDepth = routeDeep.indexOf(from.path);
      this.transitionName = toDepth > fromDepth ? "slide-left" : "slide-right";
    },
  },

  mounted() {
    this.checkUser();
    TimeMe.initialize({
      currentPageName: "thrive", // current page
      idleTimeoutInSeconds: 40 // stop recording time due to inactivity
    });
    let d = new Date();
    this.timeHash = d.getTime();

    //https://thrive.wdscode.guru/api/user/app_time

    window.onload = () => {
      setInterval(() => {
        const timeSpentOnPage = TimeMe.getTimeOnCurrentPageInSeconds();
        if (
          this.$user("id") &&
          this.$route.path !== "/login" &&
          this.$token.value
        ) {
          this.aptTime(timeSpentOnPage);
        }
      }, 20000);
    };
  },

  methods: {
    async checkUser() {
      let referral = this.$route.query.referral || "";

      // this.$getLocalStorage("thriveAppReferral")

      if (referral !== "") {
        this.$setLocalStorage("thriveAppReferral", referral);
      }

      if (
        !this.$getLocalStorage("thriveAppToken") &&
        referral === "" &&
        this.$getLocalStorage("thriveAppReferral")
      ) {
        this.$deleteLocalStorage("thriveAppReferral", "");
      }

      if (this.$getLocalStorage("thriveAppReferral")) {
        referral = this.$getLocalStorage("thriveAppReferral");
      }

      const { data } = await this.$http.post("user/useronline", {
        referral: referral
      });

      if (data.is_corporation && referral != "") {
        const corp = data.corporation;
        corp.is = true;
        this.$store.commit("corporation", corp);
        this.$setLocalStorage("splashScreenLogo", corp?.dark_logo);
      } else {
        this.$deleteLocalStorage("splashScreenLogo")
      }

      this.$store.commit("setPaymentModal");
      const { user } = data;
      if (this.isRouteAllowed) return;
      this.$store.commit("setPaymentModal", data.plaid_env == "development");
      if (user && user.stripe_card_declined) {
        this.isCardDeclined = true;
        this.$store.commit("setCardDeclined", data.card_id);
        return;
      }
      if (user && user.plaid_login_required) {
        this.isLoginRequired = true;
        this.$store.commit("setBankAuthorization", data.bank_id || true);
        return;
      }
    },
    aptTime: async function(timeSpentOnPage) {
      await this.$silentHttp.post("user/app_time", {
        token: this.$token.value,
        count: timeSpentOnPage * 1000,
        time_hash: this.timeHash
      });
    },
    goToSettings(name) {
      this.isCardDeclined = false;
      this.isLoginRequired = false;
      if (this.$route.path != "/settings") {
        this.$router.push("/settings");
      }
      this.$setState("setActiveSettings", name);
    },
    initPlaid() {
      this.recreate = 0;
      this.plaidLoad();
    }
  },
  watch: {
    "$route.path": function(data) {
      if (data != "/settings") {
        this.checkUser();
      }
    },
    "$store.state.settingName": function(data) {
      const comparison = this.$getState("isBankAuthorized")
        ? "bankAccount"
        : "manipulateCards";
      if (data != comparison) {
        this.checkUser();
      }
    }
  }
};
</script>

<style>
.text-24 {
  font-size: 1.5rem;
}

.icon-color {
  color: var(--icon-color);
}

.icon-color-fill {
  fill: var(--icon-color);
}

.step-icon {
  border: 1px solid var(--bg-color);
  color: var(--bg-color);
}

.active-step .step-icon {
  background-color: var(--bg-color);
  color: #fff !important;
}

.sign-up-or:before {
  background-color: var(--bg-color) !important;
}

.steps:before {
  border-top: 1px dashed var(--bg-color);
}

.card-component .cause-choice,
.choise-your-cause .cause-choice {
  border-bottom: 1px solid var(--bg-color);
}

.qr-bg-color {
  height: 500px;
  background-color: var(--bg-color);
  border-bottom-right-radius: 30px;
  border-bottom-left-radius: 30px;
}

.dynamic-logo {
  width: 100%;
  max-width: 310px;
  margin: 0 auto;
  margin-top: 35%;
}


.cause-single .cause-item__feature .play-buttom {
  height: 85px;
  top: 35%;
}
</style>
